var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8441 19C30.8441 12.4571 25.5429 7.15588 18.9999 7.15588C12.457 7.15588 7.15576 12.4571 7.15576 19C7.15576 24.9116 11.487 29.8117 17.1493 30.7009V22.4239H14.1405V19H17.1493V16.3905C17.1493 13.4223 18.9163 11.7827 21.6228 11.7827C22.919 11.7827 24.2744 12.0139 24.2744 12.0139V14.9272H22.7805C21.3095 14.9272 20.8506 15.8403 20.8506 16.7769V19H24.1354L23.6101 22.4239H20.8506V30.7009C26.5128 29.8117 30.8441 24.9116 30.8441 19Z",
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6883,
    height: 23.6883,
    fill: "white",
    transform: "translate(7.15576 7.15588)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.34f7f05a40ee265a2b62f1ba23f79669.svg";
export { ForwardRef as ReactComponent };